import { TypedDocumentNode, gql } from '@apollo/client';
import styled from 'styled-components';

import { PlayerImg_anyPlayer } from './__generated__/index.graphql';

const Root = styled.div`
  position: relative;
`;
const Overlay = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 33%;
`;

type Props = {
  player: PlayerImg_anyPlayer;
  overlay?: string;
};

export const PlayerImg = ({
  player: { slug, recoAvatarUrl },
  overlay,
}: Props) => {
  return (
    <Root>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="311"
        height="359"
        viewBox="0 0 311 359"
        fill="none"
      >
        <path
          d="M108.574 0.852172L108.394 0.982739C108.189 1.13211 107.885 1.35393 107.488 1.64365C106.694 2.22308 105.53 3.07412 104.048 4.16037C101.084 6.33287 96.8503 9.44616 91.7693 13.2091C81.6071 20.7352 68.0582 30.8594 54.5098 41.2529C40.9602 51.6474 27.4165 62.3071 17.2623 70.9054C12.184 75.2056 7.96207 78.983 5.0129 81.95C3.5372 83.4346 2.39072 84.7059 1.61656 85.7313C1.22926 86.2443 0.943449 86.685 0.756454 87.0518C0.564658 87.4281 0.500034 87.6823 0.5 87.8352C0.5 87.8352 0.5 87.8353 0.5 87.8353L0.547164 280.883C0.547164 289.303 5.78593 296.952 13.9592 300.399L13.9597 300.399L146.069 356.28L108.574 0.852172ZM108.574 0.852172H145.862H145.863H145.863L145.866 0.852172L145.878 0.852172L145.926 0.852171L146.108 0.852167L146.782 0.852153L149.047 0.852111L154.664 0.852051L160.924 0.852111L163.632 0.852153L164.451 0.852167L164.674 0.852171L164.732 0.852172L164.747 0.852172L164.751 0.852172H164.752H164.752H207.716L207.875 0.974961C208.07 1.12434 208.358 1.34618 208.734 1.63593C209.486 2.21542 210.588 3.06655 211.992 4.15291C214.8 6.32563 218.811 9.43926 223.624 13.2026C233.25 20.7296 246.084 30.8549 258.917 41.2496C271.752 51.6454 284.581 62.3064 294.199 70.9058C299.009 75.2065 303.007 78.9843 305.8 81.9515C307.198 83.4362 308.283 84.7075 309.016 85.7331C309.383 86.2461 309.654 86.6871 309.831 87.0547C310.013 87.431 310.076 87.6891 310.076 87.8482L310.075 280.835C310.075 289.251 304.845 296.896 296.693 300.347L164.584 356.28C161.65 357.515 158.504 358.15 155.326 358.15C152.149 358.15 149.003 357.515 146.07 356.281L108.574 0.852172Z"
          fill={`url(#pattern-${slug})`}
        />
        <defs>
          <pattern
            id={`pattern-${slug}`}
            patternContentUnits="objectBoundingBox"
            width="1"
            height="1"
          >
            <use
              xlinkHref={`#player-img-${slug}`}
              transform="matrix(0.000766828 0 0 0.00067223 0.0607391 0.0270924)"
            />
          </pattern>
          <image
            id={`player-img-${slug}`}
            width="1180"
            height="1500"
            xlinkHref={recoAvatarUrl}
          />
        </defs>
      </svg>
      <Overlay
        style={{
          background:
            overlay ||
            'linear-gradient(180deg, rgba(33, 33, 33, 0) 0%, #212121 87.88%)',
        }}
      />
    </Root>
  );
};

PlayerImg.fragments = {
  anyPlayer: gql`
    fragment PlayerImg_anyPlayer on AnyPlayerInterface {
      slug
      recoAvatarUrl: squaredPictureUrl
    }
  ` as TypedDocumentNode<PlayerImg_anyPlayer>,
};
